/* eslint-disable camelcase */
import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IData, IDataNoPagination } from '../types/shared';
import {
  INotasAcompanhamentoEmpresa,
  INotasAcompanhamentoTotalizadores,
} from '../types/notasAcompanhamento';

const BASE = '/api/v1/notas-acompanhamento';

export const useNotasAcompanhamento = () => {
  const getTotalizadores = async (
    key: QueryFunctionContext,
  ): Promise<INotasAcompanhamentoTotalizadores> => {
    const [, params] = key.queryKey as [string, { dt_inicio: string; dt_fim: string }];
    const res = await api.get<
      IDataNoPagination<INotasAcompanhamentoTotalizadores> | INotasAcompanhamentoTotalizadores
    >(`${BASE}/totalizadores/`, { params });
    const payload = res.data as
      | IDataNoPagination<INotasAcompanhamentoTotalizadores>
      | INotasAcompanhamentoTotalizadores;
    return (payload as IDataNoPagination<INotasAcompanhamentoTotalizadores>).data ?? payload;
  };

  const getEmpresas = async (
    key: QueryFunctionContext,
  ): Promise<IData<INotasAcompanhamentoEmpresa[]>> => {
    const [, params] = key.queryKey as [
      string,
      {
        dt_inicio: string;
        dt_fim: string;
        page?: number;
        size?: number;
        search?: string;
        cnpj?: string;
        codi_emp?: string;
        uf?: string;
      },
    ];
    const res = await api.get<IData<INotasAcompanhamentoEmpresa[]>>(`${BASE}/empresas/`, {
      params,
    });
    return res.data;
  };

  return {
    getTotalizadores,
    getEmpresas,
  };
};
